import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { HelpWidgetConversation } from "../types/help_widget_conversation";

interface UseSubmitConversationProps {
  onError: (error: any) => void;
  onSuccess: (ticket: any) => void;
}

interface SubmitConversationProps {
  attachment_ids: string[];
  conversation: HelpWidgetConversation;
  id: string;
}

export const useSubmitConversation = ({
  onSuccess,
  onError,
}: UseSubmitConversationProps) =>
  useMutation({
    mutationFn: async ({
      id,
      conversation,
      attachment_ids,
    }: SubmitConversationProps) =>
      reactQueryPost(internalApi.helpWidget.submitConversation({ id }), {
        id,
        conversation,
        submit_page_url: window.location.href,
        viewport_height: String(
          window.innerHeight || document.documentElement.clientHeight,
        ),
        viewport_width: String(
          window.innerWidth || document.documentElement.clientWidth,
        ),
        attachment_ids,
      }),
    onSuccess: data => onSuccess(data.ticket),
    onError: onError,
  });
